export default {
  common: {
    adminFunction: "Administrationsfunktion",
    accountManagement: "Kontoverwaltung",
    accountPermission: "Verwaltung von Konten & Berechtigungen",
    regionManagement: "Regionalverwaltung",
    zoneCountryCity: "Zone, Land & Stadt aktualisieren",
    cityWeatherManagement: "Stadtwetterdaten",
    weatherProfileBaseOnCity: "Wetterprofil basierend auf Stadt aktualisieren",
    ecatDataManagement: "Catalog-Datenverwaltung",
    ecatLibraryEquipmentsModels: "Catalog-Bibliotheksgeräte & -modelle",
    cancel: "Abbrechen",
    save: "Speichern"
  },
  account: {
    inputUserName: "E-Mail eingeben",
    thereAreNoMoreUsersLeft: "Es sind keine weiteren Benutzer mehr vorhanden.",
    superAdmin: "Superadministrator",
    global: "Global",
    region: "Region",
    regional: "Regional",
    zoneCountry: "Zone/Land",
    city: "Stadt",
    segmentMegaCity: "Segment (Mega Stadt)",
    status: "Status",
    activeStatus: "Active status",
    role: "Rolle",
    active: "Aktiv",
    inactive: "Inaktiv",
    fillRole: "Bitte wählen Sie eine Rolle"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/de.js